import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { policyEngineActions } from '@src/store/reducers/policyEngineReducer';
import { Store } from '@src/store';

@Component({
    selector: 'policy-enforcement',
    template: require('./policy-enforcement.component.html'),
    styles: [require('./policy-enforcement.component.scss')]
})
export class PolicyEnforcementComponent implements OnInit, OnDestroy  {
    public processData: any;
    public selectedItem: any;
    public indexInList: any;

    public scopes: any;
    public checkBoxItemsFilters : any;
    public enforcementList: any;

    private blockCallScopes: boolean;
    private origScopes: any;

    private readonly unsubscribe: any;
    private readonly enforcementServerToClient: any;

    constructor(private store: Store, @Inject('$filter') $filter: any) {
        this.blockCallScopes = false;
        this.enforcementServerToClient =  $filter('enforcementServerToClient');
        this.unsubscribe = this.store.subscribe(() => {
            const policyEngine = this.store.getState().policyEngine;
            if (policyEngine.scopes && policyEngine.policies_meta_data) {
                this.enforcementList = this.enforcementServerToClient(policyEngine.scopes, policyEngine.policies_meta_data)[0];
                if (!this.blockCallScopes) {
                    this.scopes = this.enforcementList;
                    this.origScopes = this.enforcementList;
                }
            }
            if (this.blockCallScopes) {
                this.blockCallScopes = false;
            }
        });

        this.checkBoxItemsFilters = [
            { name: 'Global', selected: true, disabled: false, type: 1 },
            { name: 'ProjectGroup', selected: true, disabled: false, type: 2 },
            { name: 'Project', type: 3, selected: true, disabled: false }
        ];
    }

    public async ngOnInit() {
        await this.store.dispatch({ type: policyEngineActions.GET_POLICIES_ENUMS });
        await this.store.dispatch({ type: policyEngineActions.GET_POLICIES });
        await this.store.dispatch({ type: policyEngineActions.GET_SCOPES });
    }

    public ngOnDestroy() {
        this.unsubscribe();
    }

    public onFilterChange(selectedFilter) {
        if (selectedFilter) {
            this.blockCallScopes = true;
            this.scopes = this.origScopes.filter((p) => {
                return selectedFilter.find(f => p.scopeTypeId === f.type);
            });
        } else {
            this.scopes = this.origScopes;
        }
    }

    public getDetailForScope(data) {
        const { selectedItem , indexInList } = data;
        this.indexInList = indexInList;
        this.selectedItem = selectedItem;
        if (selectedItem && !selectedItem.isNew) {
            this.store.dispatch({
                type: policyEngineActions.GET_SCOPE_DETAILS,
                payload: { scopeId: selectedItem.scopeId, typeId: selectedItem.scopeTypeId }
            }).then((resp) => {
                if (resp.data) {
                    this.selectedItem = resp.data;
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/policy-enforcement/policy-enforcement.component.ts